<template>
  <layout-raw>
    <div class="test-checkout">
      <div class="banner">TEST MODE — simulated checkout, no real card is charged</div>
      <div class="card">
        <h2>TournamentJD Test Pay</h2>
        <div v-if="order">
          <div class="line" v-for="item in order.items" :key="item.playerId">
            <span>{{ item.description }}</span><span>{{ money(item.amountCents) }}</span>
          </div>
          <div class="line total"><span>Total</span><span>{{ money(order.amountCents) }}</span></div>
          <p class="muted">Receipt to {{ order.buyerEmail }} · order #{{ order.id }}</p>

          <label>Card number</label>
          <input value="4242 4242 4242 4242" readonly />
          <div class="row">
            <div><label>Expiry</label><input value="12 / 34" readonly /></div>
            <div><label>CVC</label><input value="123" readonly /></div>
          </div>

          <p class="error" v-if="error">{{ error }}</p>
          <button class="pay" :disabled="busy || order.status !== 'Pending'" @click="complete(true)">
            {{ order.status === 'Pending' ? (busy ? 'Processing…' : 'Pay ' + money(order.amountCents)) : 'Order is ' + order.status }}
          </button>
          <button class="cancel" :disabled="busy" @click="complete(false)">Cancel and go back</button>
        </div>
        <div v-else-if="error" class="error">{{ error }}</div>
        <div v-else>Loading order…</div>
      </div>
    </div>
  </layout-raw>
</template>

<script>
import PaymentAPI from "@/services/PaymentAPI";
const paymentAPI = new PaymentAPI();

export default {
  name: "TestCheckout",
  data() {
    return {
      tournamentId: this.$route.params.tournament,
      orderId: parseInt(this.$route.query.order),
      key: this.$route.query.key || "",
      order: null,
      busy: false,
      error: "",
    };
  },
  methods: {
    money(cents) {
      return PaymentAPI.money(cents);
    },
    async complete(success) {
      this.busy = true;
      this.error = "";
      try {
        await paymentAPI.testComplete(this.orderId, this.key, success);
        if (success) {
          this.$router.push({ name: "PaymentComplete", params: { tournament: this.tournamentId }, query: { order: this.orderId, key: this.key } });
        } else {
          this.$router.push({ name: "Pay", params: { tournament: this.tournamentId }, query: { cancelled: "1" } });
        }
      } catch (e) {
        this.error = typeof e === "string" ? e : "Test payment failed.";
      } finally {
        this.busy = false;
      }
    },
  },
  async created() {
    try {
      this.order = await paymentAPI.order(this.orderId, this.key);
    } catch (e) {
      this.error = typeof e === "string" ? e : "Could not load the order.";
    }
  },
};
</script>

<style scoped>
.test-checkout { min-height: 100vh; background: #f6f8fa; font-family: -apple-system, Segoe UI, Roboto, sans-serif; }
.banner { background: #ffb300; color: #222; text-align: center; padding: 8px; font-weight: 600; }
.card { max-width: 420px; margin: 24px auto; background: white; border-radius: 12px; padding: 24px; box-shadow: 0 2px 12px rgba(0,0,0,0.08); }
.line { display: flex; justify-content: space-between; padding: 6px 0; }
.total { border-top: 1px solid #ddd; font-weight: 700; margin-top: 6px; }
.muted { color: #777; font-size: 12px; }
label { display: block; font-size: 12px; color: #555; margin-top: 12px; }
input { width: 100%; box-sizing: border-box; padding: 10px; border: 1px solid #ccc; border-radius: 6px; background: #fafafa; }
.row { display: flex; gap: 12px; }
.row > div { flex: 1; }
button { width: 100%; padding: 12px; border: 0; border-radius: 8px; margin-top: 16px; font-size: 16px; cursor: pointer; }
.pay { background: #3880ff; color: white; font-weight: 600; }
.pay:disabled { background: #9bbcf5; }
.cancel { background: transparent; color: #555; margin-top: 8px; }
.error { color: #c62828; }
</style>
